import { API_URLS } from "../constants";
import { postRequest } from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";

const importOrdersFromFR = () => {
  //If the user is redirecting from FR use the call below
  return postRequest(API_URLS.CUSTOMER.IMPORT_ORDERS_FROM_FR).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const globalService = {
  importOrdersFromFR,
};
